<template>
	<div>
		<div class="expect-job-detail" @click="showPopup">
			<span class="title-tip">不想从事的行业</span>
			<div class="selected-text">
				<span>{{selectedText}}</span>
			</div>
		</div>
		<checklist v-model="showPop" :data="list" :selects="selectedItems" :max="5" title="简历屏蔽行业" @on-close="close" @on-confirm="confirm" @on-change="dataChange">
			<p slot="extend" class="checklist-tips">我不想让以下行业搜到我的简历（可多选）</p>
		</checklist>
	</div>
</template>
<script>
import { Checklist } from '@58fe/v5';
import industry from '../../../util/industry';
import * as types from '../../../store/mutation-types';
import { mapGetters } from 'vuex';

export default {
	components: {
		Checklist
	},
	data() {
		return {
			list: industry,
			selectedItems: [], // 选中的行业
			selectedText: '无', // 选中行业名字拼接
			selectedIds: '', // 选中行业id拼接
			hasSelected: false,
			showPop: false
		};
	},
	computed: {
		...mapGetters(['blockIndustry', 'pagetypeLog'])
	},
	watch: {
		selectedItems(val) {
			if (val.length > 0) {
				this.hasSelected = true;
			}
		}
	},
	mounted() {
		window.clickLog &&
			window.clickLog('from=jl-postpingbihangye' + this.pagetypeLog);
	},
	methods: {
		showPopup() {
			this.showPop = true;
			window.clickLog &&
				window.clickLog(
					'from=jl-postpingbihangyeclick' + this.pagetypeLog
				);
		},
		close() {
			this.showPop = false;
		},
		dataChange(currentSelected) {
			// 如果最后一个看是否点击的无，则关闭选择框，并且选中项置为空
			let length = currentSelected.length;
			if (length > 0 && currentSelected[length - 1].id === '0') {
				this.confirm([]);
			}
		},
		confirm(val) {
			this.selectedItems = val;
			this.selectedText = '';
			this.selectedIds = '';
			for (let i in val) {
				if (i > 0) {
					this.selectedText += '/';
					this.selectedIds += ',';
				}
				this.selectedText += val[i].name;
				this.selectedIds += val[i].id;
			}
			this.showPop = false;
			// 选中项为空
			if (val.length === 0) {
				this.selectedText = '无';
				this.selectedIds = '';
			}
			this.$store.commit(types.SET_PRIVACY, {
				key: 'blockIndustry',
				value: this.selectedIds
			});
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.privacy-company-box,
.privacy-industry-box {
	height: px2rem(138px);
}

.privacy-show {
	background: #fff;
}

.privacy-title {
	display: block;
	color: #999;
	font-size: px2rem(28px);
	padding: px2rem(30px) 0 0 px2rem(30px);
}

.privacy-company,
.privacy-industry {
	color: #ccc;
	padding: px2rem(30px) 0 px2rem(25px);
	margin: 0 px2rem(30px);
	text-align: center;
	font-size: px2rem(24px);
	position: relative;
}

.privacy-company {
	border-bottom: 1px solid #f3f3f3;
}

.choose-company,
.choose-industry {
	font-size: px2rem(38px);
	color: #000;
	display: block;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	position: relative;
}

.selected-text {
	height: px2rem(52px);
	overflow: hidden;
	text-overflow: ellipsis;
	span {
		white-space: nowrap;
	}
}

.checklist-tips {
	height: px2rem(100px);
	line-height: px2rem(100px);
	background-color: #f8f8f8;
	color: #999;
	font-size: px2rem(28px);
	padding-left: px2rem(30px);
	border-bottom: 1px solid #e3e3e4;
}
</style>



// WEBPACK FOOTER //
// privacyIndustry.vue?16dfd26b